module.exports = __webpack_public_path__ + "static/media/svg-sprites.55a99e9e.svg";